import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FunctionsCatalogInputColumnsCard = _resolveComponent("FunctionsCatalogInputColumnsCard")
  const _component_FunctionsCatalogInputVariablesCard = _resolveComponent("FunctionsCatalogInputVariablesCard")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_FunctionsCatalogInputColumnsCard, {
      class: "p-mt-4",
      columns: _ctx.selectedFunction.inputColumns,
      readonly: _ctx.readonly
    }, null, 8, ["columns", "readonly"]),
    _createVNode(_component_FunctionsCatalogInputVariablesCard, {
      class: "p-mt-4",
      variables: _ctx.selectedFunction.inputVariables,
      readonly: _ctx.readonly
    }, null, 8, ["variables", "readonly"])
  ], 64))
}